import {Component} from '@angular/core';
import {Events, NavController, NavParams, ViewController} from 'ionic-angular';
import {HttpClient} from "@angular/common/http";
import {ApiErrorHandlerProvider} from "../../providers/api-error-handler/api-error-handler";
import {interval} from "rxjs/observable/interval";
import {takeWhile} from "rxjs/operators";
import moment from "moment";
import {TabsServiceProvider} from "../../providers/tabs-service/tabs-service";

/**
 * Generated class for the LobbyDisplayPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-lobby-display',
    templateUrl: 'lobby-display.html',
})
export class LobbyDisplayPage {

    teamId: string;
    errors: {};
    loading: boolean;
    shop: any;
    source: any;
    subscribe: any;

    constructor(
      public navCtrl: NavController,
      public viewCtrl: ViewController,
      public navParams: NavParams,
      public events: Events,
      private http: HttpClient,
      private apiErrorHandler: ApiErrorHandlerProvider,
      private tabsService: TabsServiceProvider
    ) {
        this.teamId = localStorage.getItem('currentTeamId');
    }

    ngOnInit() {
        this.refreshShop();
    }

    ionViewDidEnter() {
        this.loading = true;
        this.getShop().then((shop) => {
            this.getHolidays(shop).then((shopWithHolidays) => {
                this.shop = shopWithHolidays;
            })
        })
    }

    getShop() {
        return new Promise((resolve, reject) => {
            this.http.get(`/teams/${this.teamId}`)
                .subscribe((shop: any) => {
                    this.getBookings().then((bookings: any) => {
                        shop.users.forEach((user, index) => {
                            shop.users[index].bookings = bookings[user.id]
                        });

                        this.http.get(`/teams/${shop.id}/queue`)
                            .subscribe((response: any) => {
                                shop.queue = response;
                                return resolve(shop);
                            });
                    });
                }, error => {
                    this.errors = this.apiErrorHandler.handleError(error);
                    return reject(error);
                }, () => {
                });
        });
    }

    getBookings() {
        return new Promise((resolve, reject) => {
            this.http.get(`/teams/${this.teamId}/current-standard-bookings`)
                .subscribe((bookings: any) => {
                    return resolve(bookings);
                }, error => {
                    this.errors = this.apiErrorHandler.handleError(error);
                    return reject(error);
                }, () => {

                });
        });
    }

    getHolidays(shop) {
        return new Promise((resolve, reject) => {
            this.loading = true;
            this.http.get(`/teams/${shop.id}/staff-holiday`)
                .subscribe(holidays => {
                    shop.users.forEach((user, index) => {
                        shop.users[index].holidays = [];
                        if (holidays[user.id]) {
                            shop.users[index].holidays = holidays[user.id];
                        }
                    });
                    resolve(shop);

                }, error => {
                    this.errors = this.apiErrorHandler.handleError(error);
                    reject(error)
                }, () => {
                    this.loading = false;
                })
        });
    }

    showBarber(barber) {
        if (!barber.current_active_team) return false;
        if (barber.holidays.holidayToday) return false;

        if (barber.current_active_team !== this.shop.id) return false;

        return true;
    }

    isCurrentlyActiveBarber(barber, i) {
        return i === 0 && barber.queue_full === 0 && barber.queue_status === 1 && barber.current_active_team === this.shop.id;

    }

    isBarberUnavailable(barber) {
        if (barber.queue_status === 0 && barber.queue_full === 0) return true;
        return barber.current_active_team !== this.shop.id && barber.queue_full === 0;

    }

    isBarberQueueFull(barber) {
        return barber.queue_full === 1;

    }

    getQueueClass(barber, i) {
        if (this.isCurrentlyActiveBarber(barber, i)) return 'card-queue--highlight';
        if (this.isBarberUnavailable(barber)) return 'card-queue--full';
        return '';
    }

    refreshShop() {
        this.source = interval(30000).pipe(
            takeWhile(() => {
                if (!this.subscribe.closed) {
                    return true
                }
            })
        );

        this.subscribe = this.source
            .subscribe(() => {
                this.getShop().then((shop) => {
                    this.getHolidays(shop).then((shopWithHolidays) => {
                        this.shop = shopWithHolidays;
                    })
                })
            });
    }

    openingTime(hours, day) {
        if (hours && hours[day] !== null) {
            return this.formatTime(hours[day]) + ' - ' + this.formatTime(hours[`${day}_close`])
        }

        return 'Closed';
    }

    formatTime(time) {
        return moment(time, 'HH:mm:ss').format('h:mma');
    }

    closeModal() {
        this.tabsService.show();
        this.viewCtrl.dismiss();
    }

    ngOnDestroy() {
        this.subscribe.unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./src/pages/lobby-display/lobby-display.ts